var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.12305 3.85648V9.32471M1.12305 9.32471H6.59127M1.12305 9.32471L5.35181 5.35113C6.61033 4.09473 8.24309 3.28138 10.0041 3.03362C11.765 2.78586 13.5588 3.11712 15.1152 3.97748C16.6715 4.83784 17.9061 6.1807 18.6329 7.80372C19.3597 9.42674 19.5393 11.242 19.1447 12.976C18.7501 14.71 17.8027 16.2688 16.4451 17.4175C15.0876 18.5662 13.3935 19.2426 11.6181 19.3447C9.84276 19.4469 8.08226 18.9694 6.6019 17.984C5.12154 16.9986 4.00152 15.5588 3.41059 13.8816",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8729,
    height: 21.8729,
    fill: "white",
    transform: "translate(0.211426 0.211426)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayIcon);
export default __webpack_public_path__ + "static/media/replay-icon.171212a3ce1a9e9cbfdfd4ecdee59f4c.svg";
export { ForwardRef as ReactComponent };